import { Injectable } from '@angular/core';
import { ContactPluginFactoryService } from '../../contact/contact-plugin-factory.service';

@Injectable()
export class InstallationBobstContactPluginFactoryService extends ContactPluginFactoryService {}
